import { DndContext, DragOverlay } from "@dnd-kit/core";
import React, { useEffect, useState } from "react";
import DroppableWord from "../SortableItem/DroppableWord";

const SentenceRearranger = ({ setCurrentSlideData, contentId, data }) => {
 
  const [state, setState] = useState({ parts: [""], reArrangePart: [""] })
  const [activeId, setActiveId] = useState(null);


  useEffect(() => {
    // Update parts and userQuestion if the props change

    setCurrentSlideData((currentSlideData) => {
      let newCurrentSlidData = {
        ...currentSlideData,
        content: currentSlideData.content.map((contentObj) => {
          if (contentObj.id === contentId) {
            return {
              ...contentObj, data: state
            }
          }
          else {

            return contentObj
          }
        })
      }
      console.log(newCurrentSlidData, "newCurrentSlidData")
      return newCurrentSlidData
    })

  }, [state]);

  useEffect(() => {
    if (data) {
      setState(data)
    }
  }, [])



  const handleInputChange = (value) => {
    const wordsArray = [];
    let currentWord = "";
    let inBackticks = false;
  
    // Iterate through the characters to handle backticks
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
  
      if (char === "`") {
        inBackticks = !inBackticks;
        if (!inBackticks && currentWord) {
          // End of backtick group
          wordsArray.push(currentWord);
          currentWord = "";
        }
      } else if (char === " " && !inBackticks) {
        if (currentWord) {
          wordsArray.push(currentWord);
          currentWord = "";
        }
      } else {
        currentWord += char;
      }
    }
  
    // Push any remaining word
    if (currentWord) {
      wordsArray.push(currentWord);
    }
    
    setState((state) => {
      return { ...state,text:value , parts: wordsArray, reArrangePart: wordsArray };
    });
  };
  



  const handleDragStart = (event) => {
    if (event?.active?.id) {
      setActiveId(event.active.id);
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active?.id) {
      const draggedIndex = parseInt(active.id, 10);
      const overIndex = parseInt(over.id, 10);

      if (isNaN(draggedIndex) || isNaN(overIndex)) return;

      const updatedParts = [...state.reArrangePart];
      const draggedWord = updatedParts[draggedIndex];

      // Swap dragged word with word at the over index
      updatedParts[draggedIndex] = updatedParts[overIndex];
      updatedParts[overIndex] = draggedWord;

      setState((state) => {
        let newState = { ...state, reArrangePart: updatedParts }
        return newState
      });
    }

    setActiveId(null);
  };

  return (
    <>
      {
        state && (
          <div key={contentId} className="font-sans">

            <h1 className="text-2xl font-bold mb-4">Sentence Rearranger</h1>



            {/* Render input fields for additional parts */}

            <textarea
              key={contentId}
              value={state.text}
              placeholder="Enter sentence here"
              onChange={(e) => handleInputChange(e.target.value)}
              rows="2"
              className="w-full p-2 border border-gray-300 rounded-md mb-2"
            />


            <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
              <h3 className="text-lg font-medium mb-2">Rearrange the parts:</h3>
              <div className="flex flex-wrap gap-2 p-4 bg-gray-200 min-h-[50px] rounded-md">
                {/* Make the parts draggable */}
                {state?.reArrangePart?.map((sentence, index) => (
                  <DroppableWord key={index} id={index} sentence={sentence} />
                ))}
              </div>


              <DragOverlay>
                {activeId !== null && state.reArrangePart[activeId] && (
                  <div className="p-2 bg-blue-200 rounded-md">{state.reArrangePart[activeId]}</div>
                )}
              </DragOverlay>
            </DndContext>

            {/* <button
        onClick={handleSubmit}
        className="bg-green-500 text-white rounded-md px-4 py-2 mt-4 hover:bg-green-600"
      >
        Submit
      </button> */}
          </div>
        )
      }
    </>
  );
};

export default SentenceRearranger;
